import React from 'react';
import { useHovered } from 'components/utilities';

// Import helpers
import { getButtonHoverGradient } from 'helpers';

// Import styles
import {
	backgroundDefault,
	borderDefault,
	ButtonContainer,
	Content
} from 'components/styles';

// Import components
import { BorderButton as StyledBorderButton } from 'components/elements';

const GradientButton = React.forwardRef(({ text, icon, children }, ref) => {
	const { isHovered, supportsHover } = useHovered(ref);
	const { backgroundHover, borderHover } = getButtonHoverGradient();

	return (
		<>
			{supportsHover && (
				<ButtonContainer show={isHovered}>
					<StyledBorderButton
						backgroundGradient={backgroundHover}
						background="radial-gradient"
						border={borderHover}
					>
						<Content>
							{icon}
							{text}
							{children}
						</Content>
					</StyledBorderButton>
				</ButtonContainer>
			)}
			<ButtonContainer show={!isHovered}>
				<StyledBorderButton
					backgroundGradient={backgroundDefault}
					background="radial-gradient"
					border={borderDefault}
				>
					<Content>
						{icon}
						{text}
						{children}
					</Content>
				</StyledBorderButton>
			</ButtonContainer>
		</>
	);
});

export default GradientButton;
